<template>
  <header :class="{ 'fixed-menu': isFixed }">
    <div class="border-bottom">
      <div class="container text-center my-5">
        <div class="mb-4">
          <img
            src="../assets/img/coat-of-arms-of-georgia-sm.png"
            alt=""
            style="height: 75px"
          />
          <img
            src="../assets/img/open-society-georgia-oundation-sm.png"
            alt=""
            style="height: 75px"
            class="ms-5"
          />
        </div>
        <h2 class="mb-1 font-caps fw-bold">
          ძირითადი საკითხები თანასწორობის უფლების შესახებ
        </h2>
        <p class="mb-0">
          ელექტრონული კურსი ადგილობრივი ხელისუფლების ორგანოების
          წარმომადგენლებისათვის
        </p>
      </div>
    </div>
    <div
      class="shadow bg-white main-menu"
      ref="mainMenu"
    >
      <div
        class="
          container
          d-flex
          justify-content-center
          align-items-center
          hor-nav
        "
      >
        <MainMenu />
        <ProfileMenu :routeName="routeName"/>
      </div>
    </div>
  </header>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted, onUpdated } from "@vue/runtime-core";
import MainMenu from "@/components/MainMenu.vue";
import ProfileMenu from "@/components/ProfileMenu.vue";
import { useRoute } from 'vue-router';

export default {
  components: { MainMenu, ProfileMenu },
  setup() {
    const mainMenu = ref(null);
    const isFixed = ref(false);
    const route = useRoute()
    const routeName = ref(null)

    onUpdated(() => {
      routeName.value = route.name
    })

    onMounted(() => {
      routeName.value = route.name

      const mainMenuTopPos =
        mainMenu.value.getBoundingClientRect().top + window.scrollY;

      // const pageHeader = document.querySelector(".page-header")

      window.addEventListener("scroll", () => {
        // console.log(pageHeader)
        if (scrollY > mainMenuTopPos) {
          if (isFixed.value === false) {
            isFixed.value = true;
            // pageHeader.classList.add('fixed-menu_page-header');
          }
        } else {
          if (isFixed.value === true) {
            isFixed.value = false;
            // pageHeader.classList.remove('fixed-menu_page-header');
          }
        }
      });
    });
    

    return { mainMenu, isFixed, routeName };
  },
};
</script>

<style>
.hor-nav {
  font-size: 0.9rem;
}
.fixed-menu > .main-menu{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  min-width: 1140px;
}
.fixed-menu + .page-header{
  margin-top: 53.6px;
}
</style>